import useScrollAnimation from './useScrollAnimation'
import { Container, Box, Typography } from '@mui/material'

const SuccessTrack = () => {
  useScrollAnimation('.goal-tracker')

  return (
    <section id="goal-tracker" className="success-track text-center pad-60 position-relative">
      <Container className="container">
        <Typography variant="h2" className="mb-3 main_titel">
          Create a platform that ​ <span> works for you</span>
        </Typography>

        <Typography variant="body1" className="mb-4 w-50 m-auto">
          Unlock the full potential of your operations with a platform tailored to your unique
          needs. With complete control, you can customize workflows, manage data, improve
          visibility, optimize computations, and automate document generation, ensuring a smooth and
          efficient experience. ​
        </Typography>

        <Box
          component="img"
          src="/assets/document-templates/goal.svg"
          alt="goal"
          className="img-fluid"
          width={'1200px'}
        />

        {/* <div className="banner-people position-absolute">
          <img src="/assets/document-templates/banner-people.svg" alt="banner-people" />
        </div> */}

        <Box className="active-tempalte position-absolute">
          <Box
            component="img"
            src="/assets/document-templates/active-template.svg"
            alt="active-template"
          />
        </Box>
      </Container>
    </section>
  )
}

export default SuccessTrack
